import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportViewModule } from '@app/main/report-view/report-view.module';
import { SummaryReportModule } from '@app/main/summary-report/summary-report.module';
import { ReportModule } from '@app/main/report/report.module';
import { HomeModule } from '@app/main/home/home.module';
import { HyperlinksModule } from '@app/main/hyperlinks/hyperlinks.module';
import { GlossaryModule } from '@app/main/glossary/glossary.module';
import { AdminModule } from '@app/main/admin/admin.module';
import { ModuleActiveGuard } from '@shared/services/module-active.guard';
import { Module } from '@shared/enums/Module';
import { MainComponent } from './main.component';
import { OrgTreeModule } from './org-tree/org-tree.module';

const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        children: [
            { path: '', loadChildren: () => HomeModule, data: { animation: 'Home' } },
            {
                path: 'reports',
                loadChildren: () => ReportViewModule,
                data: { animation: 'Reports', module: Module.Reports },
                canLoad: [ModuleActiveGuard]
            },
            {
                path: 'report',
                loadChildren: () => ReportModule,
                data: { animation: 'Report', module: Module.Reports },
                canLoad: [ModuleActiveGuard]
            },
            {
                path: 'summary-reports',
                loadChildren: () => SummaryReportModule,
                data: { animation: 'SummaryReports', module: Module.SummaryReports },
                canLoad: [ModuleActiveGuard]
            },
            {
                path: 'links',
                loadChildren: () => HyperlinksModule,
                data: { animation: 'Hyperlinks', module: Module.Hyperlinks },
                canLoad: [ModuleActiveGuard]
            },
            {
                path: 'glossary',
                loadChildren: () => GlossaryModule,
                data: { animation: 'Glossary', module: Module.Glossary },
                canLoad: [ModuleActiveGuard]
            },
            { path: 'admin', loadChildren: () => AdminModule, data: { animation: 'Admin' } },
            {
                path: 'org-charts',
                loadChildren: () => OrgTreeModule,
                data: { animation: 'Organisation', module: Module.Organisation },
                canLoad: [ModuleActiveGuard]
            }
        ]
    },
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MainRoutingModule {}
